module.exports = __webpack_public_path__ + "img/logo_NPA.f06e9bbd.png";